export function DocumentsTopbar() {
  return <></>;
}
